import { z } from "zod/v4";

import { createEndpointBase } from "./core";
import {
  HistoryRequestSchema,
  ScriptsRequestSchema,
  SchedulerAggregatedHistoryRequestSchema,
  SchedulerErrorsRequestSchema,
  SchedulersRequestSchema,
  ScriptHistoryRequestSchema,
} from "../schema/bi.schema";

const base = "bi";
const bi = createEndpointBase(base);

export const biEndpoints = {
  biHistory: bi({
    method: "GET",
    path: "history",
    request: HistoryRequestSchema,
    response: z.any(),
  }),
  biScriptHistory: bi({
    method: "GET",
    path: "scriptHistory",
    request: ScriptHistoryRequestSchema,
    response: z.any(),
  }),
  biScripts: bi({
    method: "GET",
    path: "scripts",
    request: ScriptsRequestSchema,
    response: z.any(),
  }),
  biSchedulers: bi({
    method: "GET",
    path: "schedulers",
    request: SchedulersRequestSchema,
    response: z.any(),
  }),
  biSchedulerAggregatedHistory: bi({
    method: "GET",
    path: "schedulerAggregatedHistory",
    request: SchedulerAggregatedHistoryRequestSchema,
    response: z.any(),
  }),
  biSchedulerErrors: bi({
    method: "GET",
    path: "schedulerErrors",
    request: SchedulerErrorsRequestSchema,
    response: z.any(),
  }),
} as const;
